import React from "react";

function CategoriaBoton({ categoria, icono, activeCategoria, onClick }) {
  return (
    <button
      className={`w-[120px] h-[120px] bg-[#e0ded7]  flex flex-col justify-center items-center border-2 border-[#e0ded7] rounded-full font-montserrat transition-all duration-200 ${
        activeCategoria === categoria
          ? "border-2 border-[#315d86] opacity-100 translate-y-[-5px]"
          : "hover:border-[#315d86] border-2-[#315d86] opacity-80"
      }`}
      style={{
        willChange: "transform",
        boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.3)",
        padding: "5px", // Espacio interno para el contenido
      }}
      onClick={onClick}
    >
      <img src={icono} alt={categoria} className="w-10 h-10 md:w-14 md:h-14" />

      <p className="text-[20px] sm:text-[21px] md:text-[22px] lg:text-[23px] text-[#d3452f] font-bold font-dancing-script w">
        {categoria}
      </p>
    </button>
  );
}

export default CategoriaBoton;
